import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaMapMarkerAlt, FaCalendarAlt, FaUser } from 'react-icons/fa';
import './ProjectModal.css';

const ProjectModal = ({ project, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!project) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="modal-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={handleBackdropClick}
      >
        <motion.div
          className="modal-content"
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.9 }}
          transition={{ duration: 0.3 }}
        >
          <button className="modal-close" onClick={onClose} aria-label="Close modal">
            <FaTimes />
          </button>

          <div className="modal-image-wrapper">
            <img src={project.image} alt={project.title} />
            <div className="modal-image-badge">{project.category}</div>
          </div>

          <div className="modal-body">
            <h2>{project.title}</h2>

            <div className="modal-meta">
              <div className="meta-item">
                <FaMapMarkerAlt />
                <span>{project.location}</span>
              </div>
              <div className="meta-item">
                <FaCalendarAlt />
                <span>Completed {project.completionDate}</span>
              </div>
              <div className="meta-item">
                <FaUser />
                <span>{project.client}</span>
              </div>
            </div>

            <div className="modal-description">
              <h3>Project Overview</h3>
              <p>{project.description}</p>
            </div>

            <div className="modal-features">
              <h3>Key Features</h3>
              <ul>
                {project.features.map((feature, index) => (
                  <li key={index}>
                    <span className="feature-bullet">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>

            <div className="modal-actions">
              <a href="/contact" className="btn btn-primary">
                Start Similar Project
              </a>
              <button onClick={onClose} className="btn btn-secondary">
                Close
              </button>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ProjectModal;
